module.exports = __webpack_public_path__ + "img/ethan_beedie.bcb7d219.jpg";